<template>
  <section class="section with-min-height">
    <div class="center-badge"></div>
    <div class="container is-fullwidth has-text-centered">
      <p>
        Welcome back! To renew your policy and enjoy continuous coverage, please
        complete the steps below.
      </p>
      <div>
        <p>
          <b
            >1. Click the button below to view your renewal quote (optional).</b
          >
        </p>
        <a
          class="button-primary button-primary--black -spacing-static-b "
          target="_blank"
          :href="quoteDocumentLink"
        >
          View Quote
        </a>
      </div>
      <div>
        <p>
          <b
            >2. Click the button below to e-sign your renewal application
            (required).</b
          >
        </p>
        <a
          class="button-primary button-primary--black -spacing-static-b "
          target="_blank"
          :href="esignatureLink"
        >
          Sign Renewal Application
        </a>
      </div>
      <div>
        <p class="subtext">
          After you have signed the renewal application, no further action is
          required. You will receive a request to update your odometer reading
          on the usual schedule.
        </p>
        <p class="subtext">
          Thank you, and drive with confidence – you are Porsche Protected.
        </p>
        <p class="subtext concerns">
          Questions or concerns? Please call
          <span style="white-space: nowrap;"
            ><a :href="'tel:1-' + $phoneNumber">{{ $phoneNumber }}</a></span
          ><br />
          or email us at
          <span style="white-space: nowrap;"
            ><a href="mailto:customercare@porscheautoinsurance.com"
              >customercare@porscheautoinsurance.com</a
            ></span
          >
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
  props: {
    identifier: {
      type: String || null
    }
  },
  data: () => ({
    esignatureLink: null,
    quoteDocumentLink: null
  }),
  name: 'Rollover',
  beforeMount() {
    this.retrieveData();
  },
  computed: {
    ...mapGetters(['isRollover'])
  },
  methods: {
    ...mapActions(['retrieveRolloverData']),
    ...mapMutations(['toggleLoader']),
    async retrieveData() {
      this.toggleLoader();
      await this.retrieveRolloverData(this.identifier)
        .then(response => {
          if (!this.isRollover) {
            this.$snackbar.open({
              type: 'is-danger',
              message: `We were unable to locate your policy rollover information.  Please call Customer Care at 1-800-400-4128 to complete your updated policy.`,
              position: 'is-bottom',
              indefinite: true
            });
            this.toggleLoader();
            this.$router.push('/');
          } else {
            this.esignatureLink = response.data.esignature_url;
            this.quoteDocumentLink = response.data.documents_url;
            this.toggleLoader();
            return response.data;
          }
        })
        .catch(error => {
          this.toggleLoader();
          this.$snackbar.open({
            type: 'is-danger',
            message: `We were unable to locate your policy rollover information.  Please call Customer Care at 1-800-400-4128 to complete your updated policy (${error}).`,
            position: 'is-bottom',
            indefinite: true
          });
          this.$router.push('/');
        });
      // if (response.error_messages || !response) {
      //   this.toggleLoader();
      //   this.$snackbar.open({
      //     type: 'is-danger',
      //     message: `We were unable to locate your policy rollover information.  Please call Customer Care at 1-888-645-3001 to complete your updated policy.`,
      //     position: 'is-bottom',
      //     indefinite: true
      //   });
      //   this.$router.push('/');
      //   return null;
      // } else if (!this.isRollover) {
      //   this.$snackbar.open({
      //     type: 'is-danger',
      //     message: `We were unable to locate your policy rollover information.  Please call Customer Care at 1-888-645-3001 to complete your updated policy.`,
      //     position: 'is-bottom',
      //     indefinite: true
      //   });
      //   this.toggleLoader();
      //   this.$router.push('/');
      // } else {
      //   this.esignatureLink = response.data.esignature_url;
      //   this.quoteDocumentLink = response.data.documents_url;
      //   this.toggleLoader();
      //   return response.data;
      // }
    }
  }
};
</script>

<style scoped></style>
